import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AllEnterpriseModule } from "ag-grid-enterprise";
import { AgGridProvider } from "ag-grid-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GLOBAL_TOAST_CONTAINER_ID } from "./utils/accessDenied";

const modules = [AllEnterpriseModule];

function App() {
  return (
    <AgGridProvider
      modules={modules}
      licenseKey="Using_this_{AG_Grid}_Enterprise_key_{AG-125328}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Trilodocs_Limited}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{https://app.trilodocs.com/}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{https://app.trilodocs.com/}_need_to_be_licensed___{https://app.trilodocs.com/}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{2_April_2027}____[v3]_[01]_MTgwNjYyMDQwMDAwMA==327b3b1595d804c91ea35e2cdb68df8c">
      <div className="App">
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        {/* Mounted once for toasts raised outside the React tree, such as the
            403 handler in the axios response interceptors. */}
        <ToastContainer
          containerId={GLOBAL_TOAST_CONTAINER_ID}
          position="bottom-right"
          autoClose={5000}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </AgGridProvider>
  );
}

export default App;
